import React from 'react';

import ProductDetail from 'components/Tvendo/Article/DataMaster/Product/Detail/Show.js';

export default function () {
  return <ProductDetail />;
}
